import { VENDORS } from '@constants/vendors';
import { logError } from '../sentry';
const axios = require('axios');
const config = require('../../../config');
const { timeout } = config.get('apiGateway');
const ServiceResponse = require('../../models/ServiceResponse');

/**
 * Retrieve all the flags by the current bridge of the platform
 * @param {Number} page
 * @param id string
 * @param countryId
 * @param latitude
 * @param longitude
 * @param landingType
 * @param filter
 * @param sorting
 * @param filtersMetadata
 * @param headers
 * @returns {Array} object
 *
 */

const fetchVendors = async (
  page,
  id,
  countryId,
  latitude,
  longitude,
  landingType,
  filter,
  sorting,
  filtersMetadata,
  headers,
) => {
  let url = '';
  const source = axios?.CancelToken?.source();
  try {
    if (!filter) {
      // If filter was undefined show Empty State this happens when no have offer in current location
      return new ServiceResponse({ error: 404 });
    }
    const sort = sorting === undefined ? 'RANKING' : sorting;
    const size = VENDORS.VENDORS_TOTAL_BY_PAGE;
    url = `/generic-landings/api/v3/landings/${id}/vendors?landing_type=${landingType}&size=${size}&page=${page}&business_type=${filter}&sorting=${sort}`;

    const requestBody = {
      location: {
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude),
      },
      country_id: countryId,
      filter_list: filtersMetadata,
    };

    const { data } = await axios.post(url, requestBody, {
      timeout,
      headers,
      cancelToken: source?.token,
    });

    const { pagination, vendors } = data;
    if (pagination?.total === 0) return new ServiceResponse({ error: 404 });

    if (vendors.length === 0)
      return new ServiceResponse({ error: 'stop_load_vendors' });

    return new ServiceResponse({ data });
  } catch (error) {
    if (axios?.isCancel(error)) {
      logError(`[BFF][FETCH_VENDORS] - Request cancelled - url: ${url}`, error);
      return new ServiceResponse({ error: 'Request cancelled' });
    }
    logError(`[BFF][FETCH_VENDORS] - url: ${url}`, error);
    const statusCode = error?.response?.status;
    const errorMessage = error?.message || 'Unknown error occurred';

    if (statusCode) {
      return new ServiceResponse({ error: statusCode });
    }
    return new ServiceResponse({ error: errorMessage });
  }
};

export default fetchVendors;
